import VueRouter from "vue-router"
import CentroCostoList from "./components/CentroCostoList.vue"
import ChangePassword from "./components/ChangePassword.vue"
import Forbidden from "./components/Forbidden.vue"
import Home from "./components/Home.vue"
import Login from "./components/Login.vue"
import MarcaList from "./components/MarcaList.vue"
import OrdenApprove from "./components/OrdenApprove.vue"
import OrdenEdit from "./components/OrdenEdit.vue"
import OrdenImportacion from "./components/OrdenImportacion.vue"
import OrdenList from "./components/OrdenList.vue"
import OrdenListApprove from "./components/OrdenListApprove.vue"
import OrdenMassive from "./components/OrdenMassive.vue"
import OrdenNew from "./components/OrdenNew.vue"
import OrdenRestart from "./components/OrdenRestart.vue"
import OrdenView from "./components/OrdenView.vue"
import PriceSearch from "./components/PriceSearch.vue"
import ProveedorList from "./components/ProveedorList.vue"
import RenovateStock from "./components/RenovateStock.vue"
import UnidadList from "./components/UnidadList.vue"
import AsignacionItems from "./modules/asignacionItems/AsignacionItems.vue"
import Caja from "./modules/caja/Caja.vue"
import RegistrarCaja from "./modules/caja/RegistrarCaja.vue"
import VerCaja from "./modules/caja/VerCaja.vue"
import Cliente from "./modules/cliente/Cliente.vue"
import Empleado from "./modules/empleado/Empleado.vue"
import Envios from "./modules/envio/Envios.vue"
import Inventario from "./modules/inventario/Inventario.vue"
import Mixers from "./modules/mixer/Mixer.vue"
import OrdenPago from "./modules/ordenPago/OrdenPago.vue"
import OrdenVenta from "./modules/ordenVenta/OrdenVenta.vue"
import PedidoItems from "./modules/pedidoItem/PedidoItems.vue"
import ProductoList from "./modules/producto/ProductoList.vue"
import ProductoVenta from "./modules/productoVenta/ProductoVenta.vue"
import ProyectoList from "./modules/proyecto/ProyectoList.vue"
import RendicionNew from "./modules/rendicion/RendicionNew.vue"
import TransferenciaItems from "./modules/transferenciaItems/TransferenciaItems.vue"
import Usuario from "./modules/usuario/Usuario.vue"
import Vendedor from "./modules/vendedor/Vendedor.vue"
import { UsuarioService } from "./rest"
import { Storage } from "./util"

const routes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/orden",
        name: "OrdenList",
        component: OrdenList,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/massive",
        name: "OrdenMassive",
        component: OrdenMassive,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/new",
        name: "OrdenNew",
        component: OrdenNew,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/view/:id",
        name: "OrdenView",
        component: OrdenView,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/edit/:id",
        name: "OrdenEdit",
        component: OrdenEdit,
        meta: { requiresAuth: true }
    },
    {
        path: "/centroCosto",
        name: "CentroCostoList",
        component: CentroCostoList,
        meta: { requiresAuth: true }
    },
    {
        path: "/unidad",
        name: "UnidadList",
        component: UnidadList,
        meta: { requiresAuth: true }
    },
    {
        path: "/marca",
        name: "MarcaList",
        component: MarcaList,
        meta: { requiresAuth: true }
    },
    {
        path: "/proveedor",
        name: "ProveedorList",
        component: ProveedorList,
        meta: { requiresAuth: true }
    },
    {
        path: "/usuario",
        name: "Usuario",
        component: Usuario,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: "/search",
        name: "PriceSearch",
        component: PriceSearch,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/approve",
        name: "OrdenListApprove",
        component: OrdenListApprove,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/approve/:id",
        name: "OrdenApprove",
        component: OrdenApprove,
        meta: {
            requiresAuth: true,
            role: ["ADMINISTRACION", "GERENCIA", "CONTABILIDAD"]
        }
    },
    {
        path: "/orden/importacion/:id",
        name: "OrdenImportacion",
        component: OrdenImportacion,
        meta: { requiresAuth: true }
    },
    {
        path: "/orden/restart/:id",
        name: "OrdenRestart",
        component: OrdenRestart,
        meta: {
            requiresAuth: true,
            role: ["ADMINISTRACION", "GERENCIA"]
        }
    },
    {
        path: "/renovate",
        name: "RenovateStock",
        component: RenovateStock,
        meta: { requiresAuth: true }
    },
    {
        path: "/user/change-password",
        name: "ChangePassword",
        component: ChangePassword,
        meta: { requiresAuth: true }
    },
    {
        path: "/producto",
        name: "ProductoList",
        component: ProductoList,
        meta: { requiresAuth: true }
    },
    {
        path: "/caja",
        name: "Caja",
        component: Caja,
        meta: { requiresAuth: true }
    },
    {
        path: "/caja/new",
        name: "RegistrarCaja",
        component: RegistrarCaja,
        meta: { requiresAuth: true }
    },
    {
        path: "/caja/view/:id",
        name: "VerCaja",
        component: VerCaja,
        meta: { requiresAuth: true }
    },
    {
        path: "/caja/edit/:id",
        name: "ModificarCaja",
        component: RegistrarCaja,
        meta: { requiresAuth: true }
    },
    {
        path: "/rendicion/new/:id/:codigo",
        name: "RendicionNew",
        component: RendicionNew,
        meta: { requiresAuth: true }
    },
    {
        path: "/ordenPago/:ord_id",
        name: "ordenPago",
        component: OrdenPago,
        meta: { requiresAuth: true }
    },
    {
        path: "/ordenPago/:ord_id/:interfaz/:opg_id",
        name: "verOrdenPago",
        component: OrdenPago,
        meta: { requiresAuth: true }
    },
    {
        path: "/proyecto",
        name: "ProyectoList",
        component: ProyectoList,
        meta: { requiresAuth: true }
    },
    {
        path: "/empleado",
        name: "Empleado",
        component: Empleado,
        meta: { requiresAuth: true }
    },
    {
        path: "/asignaciones",
        name: "AsignacionItems",
        component: AsignacionItems,
        meta: { requiresAuth: true }
    },
    {
        path: "/transferencia",
        name: "TransferenciaItemsList",
        component: TransferenciaItems,
        meta: { requiresAuth: true }
    },
    {
        path: "/inventario",
        name: "Inventario",
        component: Inventario,
        meta: { requiresAuth: true }
    },
    {
        path: "/cliente",
        name: "cliente",
        component: Cliente,
        meta: { requiresAuth: true }
    },
    {
        path: "/productoVenta",
        name: "productoVenta",
        component: ProductoVenta,
        meta: { requiresAuth: true }
    },
    {
        path: "/ordenVenta",
        name: "ordenVenta",
        component: OrdenVenta,
        meta: { requiresAuth: true }
    },
    {
        path: "/envios",
        name: "envios",
        component: Envios,
        meta: { requiresAuth: true }
    },
    {
        path: "/mixers",
        name: "mixers",
        component: Mixers,
        meta: { requiresAuth: true }
    },
    {
        path: "/vendedor",
        name: "vendedor",
        component: Vendedor,
        meta: { requiresAuth: true }
    },
    {
        path: "/pedidoItems",
        name: "pedidoItems",
        component: PedidoItems,
        meta: { requiresAuth: true }
    },
    {
        path: "/pedidoItems/:action/:id",
        name: "verPedidoItems",
        component: PedidoItems,
        meta: { requiresAuth: true }
    },
    {
        path: "/forbidden",
        name: "Forbidden",
        component: Forbidden
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: "*",
        redirect: "/home"
    }
]

const AppRouter = new VueRouter({
    mode: "history",
    routes
})

AppRouter.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (UsuarioService.getUsuario() != null) {
            next()
        } else {
            if (to.name != "Login") {
                Storage.setObject("to", to)
            }
            AppRouter.push({
                name: "Login"
            })
        }
    } else {
        next()
    }
})

export default AppRouter